<template>
  <a-card title="Standard Deviation of Cycle Time (seconds)" size="small" class="chart-card" :loading="loading">
    <highcharts :options="chartOptions" />
  </a-card>
</template>

<script>
import { Chart } from 'highcharts-vue';

export default {
  name: 'StandardDeviationChart',
  components: {
    highcharts: Chart,
  },
  props: {
    stdDeviationData: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartData() {
      return Object.keys(this.stdDeviationData).length > 0
        ? this.stdDeviationData
        : {
            labels: [],
            std_deviation_cycle_time: [],
          };
    },
    chartOptions() {
      return {
        chart: {
          type: 'column',
          height: 400,
          backgroundColor: 'transparent',
          zoomType: 'xy',
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.chartData.labels,
          labels: {
            style: {
              fontSize: '11px',
            },
          },
        },
        yAxis: {
          title: {
            text: 'Standard Deviation (seconds)',
          },
          labels: {
            format: '{value}s',
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            colorByPoint: true,
            dataLabels: {
              enabled: true,
              format: '{y:.2f}s',
              style: {
                fontSize: '10px',
              },
            },
          },
        },
        colors: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4'],
        series: [
          {
            name: 'Standard Deviation',
            data: this.chartData.std_deviation_cycle_time,
          },
        ],
        credits: {
          enabled: false,
        },
        tooltip: {
          pointFormat: '<b>{point.y:.2f}</b> seconds',
        },
      };
    },
  },
};
</script>

<style scoped>
.chart-card {
  height: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  transition: box-shadow 0.3s ease;
}

.chart-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
